<template>
  <p class="text-xl font-bold mb-5">
    <slot />
  </p>
</template>
